export const figure20 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: 500,
        type: 'pie',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
    },
    colors: ['#ffc000', '#bfbfbf', '#00b050', '#ff0000'],
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },

    plotOptions: {
        series: {
            colorByPoint: true,
            borderWidth: 0
        },
        pie: {
            dataLabels: {
                format: '{point.name} <br /> {point.percentage}%',
                distance: -40,
                enabled: true
            }
        }
    },
    exporting: {
        enabled: false
    },
    tooltip: {
        headerFormat: '<h5 style="font-size:18px; font-weight: normal;">{point.key}</h5>',
        pointFormat: '<b>{point.percentage}%</b>',
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },

    series: [{
        size: 260,
        startAngle: 20,
        center: [200, 130],
        dataLabels: {
            distance: -55,
            enabled: true,
        },
        data: [{
            name: "Conocida", y: 39, custom: '2761', color: '#ffc000'
          }, {
            name: "Desconocida", y: 61, custom: '4839', color: '#bfbfbf'
          }
        ],
    },{
        size: 200,
        startAngle: 60,
        center: [600, 130],
        data: [
            {
                name: "Fuera de<br />riesgo", y: 26, custom: '2025', color: '#00b050'
              },
            {
            name: "En riesgo", y: 74, custom: '736', color: '#ff0000'
          }
        ],
    }]
};
